<template>
  <i class="iconfont" :class="iconName" :style="styles" @click="clickIcon"></i>
</template>
<script>
export default {
  name: 'MapleIcon',
  props: {
    size: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `maple-icon_${this.name}`
    },
    styles() {
      return {
        'font-size': this.size,
        color: this.color
      }
    }
  },
  methods: {
    clickIcon() {
      this.$emit('clickIcon')
    }
  }
}
</script>
